import { Component } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter } from 'rxjs';

@Component({
    selector: 'app-partners',
    templateUrl: './partners.component.html',
    styleUrls: ['./partners.component.css'],
    imports: [RouterModule]
})
export class PartnersComponent {
  //showMainContent: boolean = true;

  // constructor(private router: Router) {
  //   // Escucha a los eventos de navegación para ajustar la visualización del contenido principal.
  //   this.router.events.pipe(
  //     filter(event => event instanceof NavigationEnd)
  //   ).subscribe(() => {
  //     this.updateContentVisibility();
  //   });
  // }

  ngOnInit() {
    
    // Asegura que la visibilidad del contenido se ajuste correctamente al iniciar/reiniciar el componente.
    //this.updateContentVisibility();
  }


}
